module.exports = __webpack_public_path__ + "static/media/brazil.8ff840f6.svg";